import { StructuredTextDocument } from "datocms-structured-text-to-html-string";
import React from "react";
import ResponsiveContentWidthWrapper from "../ResponsiveContentWidthWrapper";
import SectionWrapper from "../SectionWrapper";
import StructuredTextGeneric from "../StructuredTextGeneric";

interface Props {
  runningText: Queries.EventPageQuery["datoCmsEvent"]["runningText"];
}

const EventPageSectionRunningText = ({ runningText }: Props) => {
  const data = runningText as unknown as StructuredTextDocument;
  return (
    <SectionWrapper noBorder additionalWrapperClassName="lg:mt-16">
      <ResponsiveContentWidthWrapper>
        <StructuredTextGeneric data={data} isRunningText />
      </ResponsiveContentWidthWrapper>
    </SectionWrapper>
  );
};

export default EventPageSectionRunningText;
